<template>
<div class="content__text-block">
      <h1 class="h1">Kontaktinformation</h1>
      <p>
        Tävlingsansvarig: Kari Vesa<br>
        telefon: <a href="tel:0703776186">0703 776 186</a><br>
        Epost: <a href="mailto:kari.vesa@live.se">kari.vesa@live.se</a>
      </p>
    </div>
</template>

<script>
export default {
  Name: 'About',
  components: {
  },

  mounted() {

  }
}
</script>